export default (state, ownProps) => {
  const data =
    typeof state.autoLoaders.loaders[ownProps["id"]] !== "undefined"
      ? state.autoLoaders.loaders[ownProps["id"]]
      : {};

  const loadingList = state.autoLoaders.loadingList;
  const loading =
    typeof loadingList[ownProps["id"]] !== "undefined" &&
    loadingList[ownProps["id"]] === true;

  const autoSuggest =
    typeof state.autoLoaders.suggesters !== "undefined"
      ? state.autoLoaders.suggesters[ownProps["id"]]
      : [];

  return {
    accessToken: state.currentUser.accessToken,
    myUser: state.currentUser.user,
    data,
    loading,
    autoSuggest,
  };
};
